// extracted by mini-css-extract-plugin
export default {"block":"t2814WTAH5fpDULFj4jP","image":"mEHSXIYhcjwc9cNbJbS4","title":"pybYvTWmIItUKQirxTpX","text":"aRyCILd4pU6gVRF4D1HZ"};